"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.WarningMessage=exports.UpdateCardForm=exports.Secure=exports.PaymentShield=exports.HeadingWrapper=exports.Heading=exports.ErrorMessage=exports.CardHeader=exports.ButtonContainer=exports.BaseLineContainer=void 0;const BaseLineContainer=exports.BaseLineContainer=_styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`,ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justtify-content: center;
  align-items: center;
`,WarningMessage=exports.WarningMessage=_styledComponents.default.div`
  margin: 10px 10px 10px 16px;
  font-size: 12px;
  color: #7c7575;
`,ErrorMessage=exports.ErrorMessage=_styledComponents.default.div`
  margin: 2px 0px 8px 0px;
  font-size: 12px;
  line-height: 18px;
  color: #C74E4E;
`,PaymentShield=exports.PaymentShield=_styledComponents.default.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #535250;
  &.margin-check{
    margin-bottom:13px
  }
`,UpdateCardForm=exports.UpdateCardForm=_styledComponents.default.div`
&.mobile{
  width:336px
}
.paymentMethodsModuleForm{
  /* padding: 0px 15px; */
  font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
  font-feature-settings: "liga" off, "calt" off;
  font-style: normal;
  font-weight: normal;
  margin: 16px 0;
  max-width:456px;
}

.paymentMethodsModuleForm .submitErrorMsg {
  color: #cc4545;
  font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.paymentMethodsModuleForm .crossIcon{
  color: #fff;
  background-color: #dd1e25;
  border-radius: 50%;
  padding: 8px;
}

.paymentMethodsModuleForm .inputContainer {
 width: 100%;
}

.paymentMethodsModuleForm .monthInputContainer {
  width: 97% !important;
 }

 .paymentMethodsModuleForm .cVVInputContainer {
  /* margin-left: 4px; */
 }

.paymentMethodsModuleForm .inputContainer .input {
  box-shadow: none;
  border-radius: 8px;
  border: 1px solid #AFAEAC;
  font-size: 16px;
  box-sizing: border-box;
  background: none;
  padding: 20px 16px 6px 16px;
  width: 100%;
  height: 56px;
  color: #2b0810;
}

.paymentMethodsModuleForm .inputContainer  {
  display: flex;
  flex-direction: column;
  position: relative;
}

.paymentMethodsModuleForm .inputContainer:focus-within label {
  transform: translate(0, 10px) scale(0.7);
}

.paymentMethodsModuleForm .inputContainer label {
  color: #7d7b78;
  padding: 0px 16px;
  position: absolute;
  transform: translate(0, 19px) scale(1);
  transform-origin: top left;
  transition: all 0.2s ease-out;
  z-index: -1;
}

.paymentMethodsModuleForm .inputContainer .activeLabel {
  transform: translate(0, 10px) scale(0.72);
  padding-left:24px
}

.paymentMethodsModuleForm .inputContainer .input.error{
  border: 1px solid #cc4545;
  font-weight: normal;
}

.paymentMethodsModuleForm .inputContainer .input:focus,
.paymentMethodsModuleForm .inputContainer .input.error:focus {
  border: 0px solid #3E7CA8 !important;
  outline: #3E7CA8 solid 2px !important;
}

.paymentMethodsModuleForm .monthCVVContainer{
  display: flex;
}

.paymentMethodsModuleForm .monthCVVContainer .width100{
  width: 100%;
}

.backdrop{
  z-index: 5 !important;
}

.backButton{
  margin-left: -13px;
}
`,HeadingWrapper=exports.HeadingWrapper=_styledComponents.default.div`
  width: 100%;
  text-align: left;
`,Heading=exports.Heading=_styledComponents.default.div`
  font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
  font-size: 20px;
  margin: 24px 0px 24px 0px;
  display: flex;
  align-items: center;
`,CardHeader=exports.CardHeader=_styledComponents.default.div`
  font-style: normal;
  font-weight: 300;
  font-size: 28px;
  line-height: 34px;
  color: #2a2928;
`,Secure=exports.Secure=_styledComponents.default.div`
  align-items: baseline;
  display: grid;
  margin-top: 8px;
  width: 100%;
`;